import useSWRMutation from 'swr/mutation';
import clickstreamAPI from '../axiosInstance';
import { TrackEventRequest, TrackEventResponse } from './types';

export function trackEventsRequest() {
  return useSWRMutation<TrackEventResponse, Error, string, TrackEventRequest>(
    '/api/clickstream',
    (_, { arg }) =>
      clickstreamAPI('/api/clickstream', {
        method: 'post',
        data: arg,
      })
        .then((response) => response.data)
        .catch(() => {
          console.log('Clickstream error');

          return { success: false, message: 'Clickstream error' };
        })
  );
}
